import { React, useState, useEffect, useRef, useContext } from "react";
import PCModal from "../modal/PC/PCModal";
import Select from 'react-select';
import Button from "@mui/material/Button";
import axios from "axios";
import { AppContext } from '../AppStore';
import Swal from "sweetalert2";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import GridNoRow from '../common/GridNoRow';
import { DataGrid, GridActionsCellItem, useGridApiRef } from '@mui/x-data-grid';
import Moment from 'moment';
import "moment/locale/ko";

let questionFile1 = null;
let questionFile2 = null;
let questionFile3 = null;
function QuestionModal({ questionModalClose }) {
  const appStore = useContext(AppContext);
  const [tabID, setTabID] = useState('1');
  const [inputs, setInputs] = useState({
    question_id: 0,
    question_title: '',
    question_contents: '',
    question_file1: '',
    question_file2: '',
    question_file3: '',
    answer_datetime: '',
    answer_contents: '',
    reg_user_id:'',
    reg_user_name:'',
    reg_datetime: '',
    update_user_id:'',
    update_user_name:'',
    update_datetime:''
  });
  const [view, setView] = useState({
    question_title: '',
    question_contents: '',
    question_file1: '',
    question_file2: '',
    question_file3: '',
    answer_datetime: '',
    answer_contents: '',
    reg_user_id:'',
    reg_user_name:'',
    reg_datetime: ''
  });
  const fileInputRef1 = useRef(null);
  const fileInputRef2 = useRef(null);
  const fileInputRef3 = useRef(null);
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const [selectQuestionID, setSelectQuestionID] = useState('');

  useEffect(() => {
      handleSetting();
      handleView();
  }, []);

  useEffect(() => {
      //렌더링 될 때 마다 실행된다.
  });

  const handleTabID = (event, newTabID) => {
    setTabID(newTabID);

    if(String(newTabID) === '2'){
      setView({
        question_title: '',
        question_contents: '',
        question_file1: '',
        question_file2: '',
        question_file3: '',
        answer_datetime: '',
        answer_contents: '',
        reg_user_id:'',
        reg_user_name:'',
        reg_datetime: ''
      });
      setSelectQuestionID('');
    }
  };

  const handleSetting = () => {
    setColumns([
      { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
      { field: 'answer_yn', headerName: 'answer_yn', width: 0, headerAlign: 'center', align:'left' },
      { field: 'answer_yn_name', headerName: '상태', width: 80, headerAlign: 'center', align:'left' },
      { field: 'question_title', headerName: '문의제목', width: 150, headerAlign: 'center', align:'left' },
      { field: 'question_contents', headerName: '문의내용', width:350, headerAlign: 'center', align:'left' },
      { field: 'question_file1', headerName: '첨부파일1', width: 0, headerAlign: 'center', align:'left' },
      { field: 'question_file2', headerName: '첨부파일2', width: 0, headerAlign: 'center', align:'left' },
      { field: 'question_file3', headerName: '첨부파일3', width: 0, headerAlign: 'center', align:'left' },
      { field: 'answer_contents', headerName: '답변내용', width: 0, headerAlign: 'center', align:'left' },
      { field: 'answer_datetime', headerName: '답변일시', width: 0, headerAlign: 'center', align:'left' },
      { field: 'reg_user_id', headerName: '등록자ID', width: 0, headerAlign: 'center', align:'left' },
      { field: 'reg_user_name', headerName: '등록자', width: 120, headerAlign: 'center', align:'center' },
      { field: 'reg_datetime', headerName: '등록일시', width: 180, headerAlign: 'center', align:'center' },
      
    ]);
  };

  const [columnVisibilityModel, setColumnVisibilityModel] = useState({
    id: false,
    answer_yn: false,
    answer_yn_name: true,
    question_title: true,
    question_contents: true,
    question_file1: false,
    question_file2: false,
    question_file3: false,
    answer_contents: false,
    answer_datetime: false,
    reg_user_id: false,
    reg_user_name: true,
    reg_datetime: true
  });

  useEffect(() => {
    if(selectQuestionID !== ''){
        for(let i=0; i<rows.length; i++){
          if(rows[i].id === selectQuestionID){
            setView({
              question_title: rows[i].question_title,
              answer_yn: rows[i].answer_yn,
              answer_yn_name: rows[i].answer_yn_name,
              question_contents: rows[i].question_contents,
              question_file1: rows[i].question_file1,
              question_file2: rows[i].question_file2,
              question_file3: rows[i].question_file3,
              answer_datetime: typeof rows[i].answer_datetime === 'undefined'? '':Moment(rows[i].answer_datetime).format('YYYY-MM-DD HH:mm:ss'),
              answer_contents: rows[i].answer_contents,
              reg_user_id: rows[i].reg_user_id,
              reg_user_name: rows[i].reg_user_name,
              reg_datetime: Moment(rows[i].reg_datetime).format('YYYY-MM-DD HH:mm:ss')
            })
            setTabID('3');
          }
        }
    }
  }, [selectQuestionID]);

  const handleView = () => {
    axios.get('/api/Common/Question')
    .then((response) => {
      var array = response.data.map((item, index) => ({
        id: item.question_id,
        question_title: item.question_title,
        answer_yn: item.answer_yn,
        answer_yn_name: item.answer_yn_name,
        question_contents: item.question_contents,
        question_file1: item.question_file1,
        question_file2: item.question_file2,
        question_file3: item.question_file3,
        answer_contents: item.answer_contents,
        answer_datetime: item.answer_datetime,
        reg_user_id: item.reg_user_id,
        reg_user_name: item.reg_user_name,
        reg_datetime: (item.reg_datetime === undefined?'':Moment(item.reg_datetime).format('YYYY-MM-DD HH:mm:ss')),
      }));
      setRows(array);
    })
    .catch((error) => {
        console.log(error);
    });
  };

  const handleInitSelect = () => {
    /*
    axios.get('/api/Common/Profile')
    .then((response) => { 
      setInputs({
        user_id: response.data.user_id,
        user_name: response.data.user_name,
        password:'',
        password_confirm: '',
        user_call: response.data.user_call,
        user_email: response.data.user_email,
        user_phone: response.data.user_phone,
        bank: response.data.user_account_bank,
        bank_number: response.data.user_account_number,
        user_note: response.data.user_note
      });
    })
    .catch((error) => {
        console.log(error);
    });
    */
  };
  
  const handleFileDelete = (number) => {
    let nextInputs = {
      ...inputs
    };
    if(String(number) === '1'){
      questionFile1 = null;
      nextInputs = {
        ...inputs,
        ['question_file1']: '', 
      };
      if (fileInputRef1.current) fileInputRef1.current.value = '';
    }else if(String(number) === '2'){
      questionFile2 = null;
      nextInputs = {
        ...inputs,
        ['question_file2']: '', 
      };
      if (fileInputRef2.current) fileInputRef2.current.value = '';
    }else if(String(number) === '3'){
      questionFile3 = null;
      nextInputs = {
        ...inputs,
        ['question_file3']: '', 
      };
      if (fileInputRef3.current) fileInputRef3.current.value = '';
    }
    setInputs(nextInputs);
  };

  const onChange = (e)=>{
    const {name, value, files} = e.target;
    
    // 파일 입력인 경우 파일명을 저장
    if (files && files.length > 0) {
      const nextInputs = {
        ...inputs,
        [name]: files[0].name, 
      };
      setInputs(nextInputs);

      if(name === 'question_file1'){
        questionFile1 = files[0];
      }else if(name === 'question_file2'){
        questionFile2 = files[0];
      }else if(name === 'question_file3'){
        questionFile3 = files[0];
      }

    } else {
      const nextInputs = {
        ...inputs,
        [name]: value, 
      };
      setInputs(nextInputs);
    }
  };

  const handleSave = () => {
    let msg = '';
    if(inputs.question_title.trim() === ''){
      msg = '문의제목은 필수로 입력 해주세요.';
    }else if(inputs.question_contents.trim() === ''){
      msg = '문의내용은 필수로 입력 해주세요.';
    }else{
      
      axios.post("/api/Common/QuestionReg", {inputs} ,
      { withCredentials: true })
      .then(function (response) {
        if(response.status === 200){

          var selectID = response.data;
          if(questionFile1 !== null || questionFile2 !== null || questionFile3 !== null){
            const formData = new FormData();
            formData.append('selectID', selectID);
            formData.append('folder', 'Question');
            formData.append('File1', questionFile1);
            formData.append('File2', questionFile2);
            formData.append('File3', questionFile3);

            axios.post('/api/SaveCommon/FileSave'
                , formData
                , { headers: { 'Content-Type': 'multipart/form-data' } 
            });
          }
          
          Swal.fire({
            title: '1:1문의 등록 완료',
            text: '정상적으로 1:1문의가 등록 되었습니다.',
            confirmButtonText: '확인',
            timer:5000,
            timerProgressBar: true
          }).then((result) => {
            handleView();
            setInputs({
              question_id: 0,
              question_title: '',
              question_contents: '',
              question_file1: '',
              question_file2: '',
              question_file3: '',
              answer_datetime: '',
              answer_contents: '',
              reg_user_id:'',
              reg_user_name:'',
              reg_datetime: '',
              update_user_id:'',
              update_user_name:'',
              update_datetime:''
            });
            setTabID('2');
          });
        }else{
          appStore.capture();
        }
      })
      .catch(function (error) {
          appStore.capture();
      });
    }
    if(msg !== ''){
      Swal.fire({
        title: '<p style="color:red">1:1문의 등록 오류</p>',
        html: msg,
        confirmButtonText: '확인'
      });
    }
  };

  return (
    <PCModal onClose={questionModalClose} title={"1:1문의"}>
        <div className="modal" style={{ height : '540px', overflowY: 'auto'}}>
          <TabContext value={tabID}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <TabList onChange={handleTabID} style={{ paddingLeft: '20px'}}>
              <Tab label="문의등록" value="1" />
              <Tab label="문의내역" value="2" />
              <Tab label="문의상세" value="3" disabled />
            </TabList>
          </Box>
          <TabPanel value="1">
            <div>
              <table className="ModalTABLE">
                <tbody>
                  
                  <tr>
                    <td className="ModalTD" colSpan={2}>
                      <div className="modal_filed">
                        <div className="modal_filed_title">문의제목</div>
                        <div className="modal_filed_input">
                          <input type="text" value={inputs.question_title} name="question_title" onChange={(e) => onChange(e) } style={{width: '755px'}} autoComplete="off" />
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="ModalTD" colSpan={2}>
                      <div className="modal_filed">
                        <div className="modal_filed_title">문의내용</div>
                        <div className="modal_filed_input">
                          <textarea name="question_contents" value={inputs.question_contents} onChange={(e) => onChange(e) } style={{width: '768px', height: '115px', marginTop:'10px', border:'2px lightgrey solid', borderRadius: '5px', fontSize:'17px', fontFamily:'none', resize:'none'}} autoComplete="off">
                          </textarea>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="ModalTD" colSpan={2}>
                      <div className="modal_filed">
                        <div className="modal_filed_title" style={ { paddingTop: '3px'} }>첨부파일 1</div>
                        <div className="modal_filed_input" style={{width: '765px'}}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                            <input 
                              type="file" 
                              name="question_file1" 
                              ref={fileInputRef1}
                              onChange={(e) => onChange(e) } 
                              style={{
                                width: '765px',
                                padding: '8px',
                                border: '2px solid #ddd',
                                borderRadius: '5px',
                                fontSize: '14px',
                                backgroundColor: '#f9f9f9',
                                cursor: 'pointer'
                              }} 
                              autoComplete="off" 
                            />
                            {inputs.question_file1 && (
                              <Button 
                                onClick={ ()=> handleFileDelete('1') }
                                className="btn-p"
                                style={{padding: "2px 5px", margin: "0px", width:"50px"}}
                                sx={{
                                    m: 1, 
                                    fontSize: 15, 
                                    color: "white", 
                                    borderColor: "#FF3636", 
                                    backgroundColor: "#FF3636"
                                }} 
                                variant="outlined">
                                삭제
                              </Button>
                            )}
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="ModalTD" colSpan={2}>
                      <div className="modal_filed">
                        <div className="modal_filed_title" style={ { paddingTop: '3px'} }>첨부파일 2</div>
                        <div className="modal_filed_input" style={{width: '765px'}}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                            <input 
                              type="file" 
                              name="question_file2" 
                              ref={fileInputRef2}
                              onChange={(e) => onChange(e) } 
                              style={{
                                width: '765px',
                                padding: '8px',
                                border: '2px solid #ddd',
                                borderRadius: '5px',
                                fontSize: '14px',
                                backgroundColor: '#f9f9f9',
                                cursor: 'pointer'
                              }} 
                              autoComplete="off" 
                            />
                            {inputs.question_file2 && (
                              <Button 
                                onClick={ ()=> handleFileDelete('2') }
                                className="btn-p"
                                style={{padding: "2px 5px", margin: "0px", width:"50px"}}
                                sx={{
                                    m: 1, 
                                    fontSize: 15, 
                                    color: "white", 
                                    borderColor: "#FF3636", 
                                    backgroundColor: "#FF3636"
                                }} 
                                variant="outlined">
                                삭제
                              </Button>
                            )}
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="ModalTD" colSpan={2}>
                      <div className="modal_filed">
                        <div className="modal_filed_title" style={ { paddingTop: '3px'} }>첨부파일 3</div>
                        <div className="modal_filed_input" style={{width: '765px'}}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                            <input 
                              type="file" 
                              name="question_file3" 
                              ref={fileInputRef3}
                              onChange={(e) => onChange(e) } 
                              style={{
                                width: '765px',
                                padding: '8px',
                                border: '2px solid #ddd',
                                borderRadius: '5px',
                                fontSize: '14px',
                                backgroundColor: '#f9f9f9',
                                cursor: 'pointer'
                              }} 
                              autoComplete="off" 
                            />
                            {inputs.question_file3 && (
                              <Button 
                                onClick={ ()=> handleFileDelete('3') }
                                className="btn-p"
                                style={{padding: "2px 5px", margin: "0px", width:"50px"}}
                                sx={{
                                    m: 1, 
                                    fontSize: 15, 
                                    color: "white", 
                                    borderColor: "#FF3636", 
                                    backgroundColor: "#FF3636"
                                }} 
                                variant="outlined">
                                삭제
                              </Button>
                            )}
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="ModalTD" colSpan={2}>
                      <div className="modal_action">
                        <div className="modal_button">
                          <Button 
                            onClick={()=> { questionModalClose?.(); }}
                            className="btn-p"
                            sx={{  
                                m: 1, 
                                fontSize: 15, 
                                color: "white", 
                                borderColor: "#808080", 
                                backgroundColor: "#808080",
                                ":hover": { boxShadow: "2px 2px 2px #808080" , backgroundColor: "#808080", borderColor: "#808080"}
                            }} 
                            variant="outlined">
                            닫기
                          </Button>
                        </div>
                        <div className="modal_button">
                          <Button 
                            onClick={handleSave}
                            className="btn-p btn-u"
                            sx={{  
                                m: 1, 
                                fontSize: 18, 
                                color: "white", 
                                borderColor: "#FF3636", 
                                backgroundColor: "#FF3636",
                                ":hover": { boxShadow: "2px 2px 2px #FF3636" , backgroundColor: "#FF3636", borderColor: "#FF3636"}
                            }} 
                            variant="outlined">
                            등록
                          </Button>
                        </div>
                      </div>
                    </td>
                  </tr>

                </tbody>
              </table>
            </div>
          </TabPanel>
          
          <TabPanel value="2">
            <div>
              <table className="ModalTABLE">
                <tbody>
                  <tr>
                    <td>
                      <div className="modal_grid" style={{ height: '392px' }}>
                        <DataGrid
                          rows={rows}
                          columns={columns}
                          columnVisibilityModel={columnVisibilityModel}
                          onRowSelectionModelChange={(newSelectedIds) => {
                              setSelectQuestionID(newSelectedIds[0]);
                          }}
                          selectedIds={selectQuestionID}
                          AlternatingRowBackground="LavenderBlush"
                          rowsPerPageOptions={[20, 50, 100]}
                          initialState={{ 
                              density: 'compact'
                          }}
                          slots={{
                              noRowsOverlay: GridNoRow,
                          }} />
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="ModalTD" colSpan={2}>
                      <div className="modal_action">
                        <div className="modal_button">
                          <Button 
                            onClick={()=> { questionModalClose?.(); }}
                            className="btn-p"
                            sx={{  
                                m: 1, 
                                fontSize: 15, 
                                color: "white", 
                                borderColor: "#808080", 
                                backgroundColor: "#808080",
                                ":hover": { boxShadow: "2px 2px 2px #808080" , backgroundColor: "#808080", borderColor: "#808080"}
                            }} 
                            variant="outlined">
                            닫기
                          </Button>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </TabPanel>

          <TabPanel value="3">
            <div>
              <table className="ModalTABLE">
                <tbody>
                  
                  <tr>
                    <td className="ModalTD" colSpan={2}>
                      <div className="modal_filed">
                        <div className="modal_filed_title" style={ { paddingTop: '6px' } }>문의제목</div>
                        <div className="modal_filed_input">
                          <input type="text" value={view.question_title} style={{width: '755px'}} autoComplete="off" readOnly />
                        </div>
                      </div>
                    </td> 
                  </tr>
                  <tr>
                    <td className="ModalTD" colSpan={2}>
                      <div className="modal_filed">
                        <div className="modal_filed_title">문의내용</div>
                        <div className="modal_filed_input">
                          <textarea value={view.question_contents} style={{width: '768px', height: '70px', marginTop:'10px', border:'2px lightgrey solid', borderRadius: '5px', fontSize:'17px', fontFamily:'none', resize:'none'}} autoComplete="off" readOnly>
                          </textarea>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="ModalTD" colSpan={2}>
                      <div className="modal_filed">
                        <div className="modal_filed_title">답변내용</div>
                        <div className="modal_filed_input">
                          <textarea value={view.answer_contents} style={{width: '768px', height: '70px', marginTop:'10px', border:'2px lightgrey solid', borderRadius: '5px', fontSize:'17px', fontFamily:'none', resize:'none'}} autoComplete="off" readOnly>
                          </textarea>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="ModalTD" colSpan={2}>
                      <div className="modal_filed">
                        <div className="modal_filed_title">첨부파일</div>
                        <div className="modal_filed_input" style={{ width: '768px', paddingTop: '10px' }}>
                          <span style={ { display:'block', fontWeight: 'bold', cursor: 'pointer', height: '18.8px' } }>{ view.question_file1 }</span>
                          <br/>
                          <span style={ { display:'block', fontWeight: 'bold', cursor: 'pointer', height: '18.8px' } }>{ view.question_file2 }</span>
                          <br/>
                          <span style={ { display:'block', fontWeight: 'bold', cursor: 'pointer', height: '18.8px' } }>{ view.question_file3 }</span>
                        </div>
                      </div>
                    </td>
                  </tr>
                  {/*
                  <tr>
                    <td className="ModalTD">
                      <div className="modal_filed">
                        <div className="modal_filed_title">등록일시</div>
                        <div className="modal_filed_input">
                          <input type="text" value={view.reg_datetime} autoComplete="off" readOnly />
                        </div>
                      </div>
                    </td>
                    <td className="ModalTD">
                      <div className="modal_filed">
                        <div className="modal_filed_title">답변일시</div>
                        <div className="modal_filed_input">
                          <input type="text" value={view.answer_datetime} autoComplete="off" readOnly />
                        </div>
                      </div>
                    </td>
                  </tr>
                  */}
                  <tr>
                    <td className="ModalTD" colSpan={2}>
                      <div className="modal_action">
                        <div className="modal_button">
                          <Button 
                            onClick={()=> { questionModalClose?.(); }}
                            className="btn-p"
                            sx={{  
                                m: 1, 
                                fontSize: 15, 
                                color: "white", 
                                borderColor: "#808080", 
                                backgroundColor: "#808080",
                                ":hover": { boxShadow: "2px 2px 2px #808080" , backgroundColor: "#808080", borderColor: "#808080"}
                            }} 
                            variant="outlined">
                            닫기
                          </Button>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </TabPanel>
          </TabContext>
        </div>
    </PCModal>
  );
}

export default QuestionModal;
